<template>
<section>
            <div class="shedule_date_data_paddi">
                <div class="shedule_date_data_scroll">
                    <div class="shedule_date_data">
                        <div class="shedule_date_inner shedule_date_inner_btm">
                            <h5>City</h5>
                            <p>{{details.cityName}}</p>
                        </div>

                        <div class="shedule_date_inner shedule_date_inner_btm">
                            <h5>Zone</h5>
                            <p>{{details.areaName}}</p>
                        </div>

                        <div class="shedule_date_inner shedule_date_inner_btm">
                            <h5>Collection Division</h5>
                            <p>{{details.divisionName}}</p>
                        </div>

                        <div class="shedule_date_inner shedule_date_inner_btm">
                            <h5>Surveyor</h5>
                            <p>{{details.surveyorName}}</p>
                        </div>

                        <!-- next -->
                        <div class="shedule_date_inner shedule_date_inner_btm">
                            <h5>Survey Schedule</h5>
                            <p>{{details.startDate + ' to ' + details.endDate}}</p>
                        </div>

                        <!-- <div class="shedule_date_inner">
                                <h5>Survey start</h5>
                                <p>{{details.startDate}}</p>
                            </div>
                            <div class="shedule_date_inner">
                                <h5>Survey end</h5>
                                <p>{{details.endDate}}</p>
                            </div> -->
                        <div class="shedule_date_inner shedule_date_inner_btm">
                            <h5>Survey Start Date and Time</h5>
                            <p>{{details.surveyedOn }}</p>
                        </div>
                        <div class="shedule_date_inner shedule_date_inner_btm">
                            <h5>Total Houses</h5>
                            <p>{{details.totalHouseCount}}</p>
                        </div>
                        <!-- next -->
                        <div class="shedule_date_inner shedule_date_inner_btm">
                            <h5>Active Houses</h5>
                            <p>{{details.activeHouseCount}}</p>
                        </div>
                        <div class="shedule_date_inner shedule_date_inner_btm">
                            <h5>Inactive Houses</h5>
                            <p>{{details.inactiveHouseCount}}</p>
                        </div>

                        <div class="shedule_date_inner shedule_date_inner_btm">
                            <h5>Pending Marking</h5>
                            <p>{{details.pendingHouseCount}}</p>
                        </div>
                        <div class="shedule_date_inner shedule_date_inner_btm">
                            <h5>Survey Status</h5>
                            <p>{{details.surveyStatus}}</p>
                        </div>
                        <div class="shedule_date_inner">
                            <h5>Survey Completion Date and Time</h5>
                            <p>{{details.completed ? details.completed : '--'}}</p>

                        </div>
                        <div class="shedule_date_inner">
                            <button role="button" class="view-houses" v-on:click="houseLocationOnMap">View Houses</button>
                        </div>
                    </div>
                </div>
         </div>

        <!-- </div> -->
        <!-- <div class="shedule_date_data_paddi">
        <div class="col-md-6">
            <multiLocation/>
        </div>
        </div> -->

    <!-- </div> -->

    <div v-if="isMapActive" class="">
        <div class="location">
                <div id="details" class="overlay waste_type_pop">
                    <div class="overlay_inner">
                        <div class="row form-modal">
                            <div class="d-flex justify-right">
                                <button @click="onCloseMap" v-bind:class="'mr-5  btn btn-default close-button'">
                                X
                            </button>
                            </div>
                            <div v-if="houseLocation" class="map-show">
                                <multiLocation :user="'SurveyDetailsMap'"/>
                            </div>
                            <div v-if="!houseLocation" class="text-center">
                                No records Found
                            </div>
                            <div class="d-flex justify-right">
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>
    
    <v-server-table class="surveyDetailsTable_paddi surveyDetailsTable_paddi_res" ref="surveyDetailsTable" url :limit="5" :columns="columns" :options="options" @loaded="onLoaded">
        <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
                <td class="text-center" colspan="9">
                    <pulse-loader></pulse-loader>
                </td>
            </tr>
        </template>
    </v-server-table>

</section>
</template>

<script>
import {
    USER_ROLES
} from '../../../config';
import {
    ServerTable,
    Event
} from 'vue-tables-2';
import {
    mapState
} from 'vuex';

import store from '../../../store';
import swal from 'sweetalert2';
import moment from 'moment';
import dateFormatter from "../../utilities/dateFormate";

import {
    eventBus,
    surveysService,
} from "../../../services";
import {
    error,
    log
} from 'console';

import multiLocation from "../gmapLocation/multiLocation";

export default {
    name: 'surveyDetails',
    components: {
        multiLocation
    },
    data() {
        return {
            loading: null,
            surveyDetailsTable: null,
            parameters: {},
            statusValue: '',
            housesInfo: [],
            details: {},
            dataa: '--',
            isMapActive:false,
            houseLocation:true,
            columns: ['lineTowerName', 'hnNo', 'houseTag', 'houseType','contactPerson', 'contact', 'memberCount', 'surveyOn', 'surveyor', 'status'],
            options: {
                highlightMatches: true,
                sortable: ['lineTowerName', 'hnNo', 'houseTag', 'houseType', 'contactPerson', 'contact', 'memberCount', 'surveyOn'],
                headings: {
                    lineTowerName: 'Line / Tower',
                    hnNo: 'House Number',
                    houseTag: 'Tag',
                    houseType: 'House Type',
                    contactPerson: 'Contact Person',
                    contact: 'Contact Number',
                    memberCount: 'Family Members',
                    surveyOn: 'Survey on',
                    surveyor: 'Surveyor Name',
                    status: 'Status',
                },
                requestFunction: request => {
                    this.parameters.page = request.page;
                    this.parameters.limit = request.limit;
                    this.parameters.sortBy = "createdAt";
                    this.parameters.sortOrder = "des";
                    this.parameters.searchString = "";
                    if (request.orderBy) {

                        // if(request.orderBy == 'houseNumber'){
                        //   this.parameters.sortBy = 'hnNo';

                        // }
                        if(request.orderBy == 'houseType'){
                            this.parameters.sortBy = 'houseTypeId.name';
                            }else{
                            this.parameters.sortBy = request.orderBy;
                            }
                            // this.parameters.sortBy = request.orderBy;
                            if (request.ascending == 1) {
                                this.parameters.sortOrder = "asc";
                            } else {
                                this.parameters.sortOrder = "des";
                            }
                    }

                    if (request.query.status) {
                        this.parameters.status = request.query.status;
                    }
                    if (request.query != "") {
                        this.parameters.searchString = request.query;
                    }
                    this.loading = true;
                    return surveysService.getHousesBySurveyId(this.$route.params._id, this.parameters)
                        .catch(error => {
                            console.error('survey.requestFunction-error:', error);
                            this.$snotify.error('Get Survey', 'Error!');
                        });
                },
                responseAdapter: response => {
                    this.loading = false;
                    let surveyDetails = {}
                    surveyDetails = response.data.response[0]
                    let dataResp = [];
                    response.data.response.forEach((element) => {
                        let finalData = {};
                        finalData["lineTowerName"] = element.lineTowerName ? element.lineTowerName : '--';
                        finalData["hnNo"] = element.hnNo ? element.hnNo : '--';
                        finalData["houseTag"] = element.houseTag ? element.houseTag : '--';
                        finalData["geoLoc"] = element.geoLoc ? element.geoLoc.reverse().join() : '--';
                        finalData["houseType"] = element.houseType ? element.houseType : '--';
                        finalData["contactPerson"] = element.contactPerson ? element.contactPerson : '--';
                        finalData["contact"] = element.contact ? element.contact : '--';
                        finalData["memberCount"] = element.memberCount ? element.memberCount : '0';
                        let surveyOnDate = element.surveyOn ? dateFormatter(element.surveyOn) : '--';
                        finalData["surveyOn"] = surveyOnDate;
                        finalData["houseType"] = element.houseTypeId ? element.houseTypeId.name : '--';
                        // finalData["surveyOn"] = element.surveyOn ? new Date(element.surveyOn).toLocaleDateString() : '--';
                        finalData["surveyor"] = surveyDetails.surveyorName ? surveyDetails.surveyorName : '--';
                        finalData["status"] = element.houseStatus;
                        dataResp.push(finalData);
                        this.dataa = dataResp[0]['surveyOn'] ? dataResp[0]['surveyOn'] : '--';
                    });
                    return {
                        data: dataResp,
                        count: response.data.total || 0,
                    };
                },
                uniqueKey: '_id',
            },
        };

    },
    methods: {
        getSurveyInfo() {
            return surveysService.getSurveyById(this.$route.params._id).then((response) => {
                this.loading = false;
                let surveyDetails = response.data.response
                this.details = response.data.response
                let surveyStatus = surveyDetails.surveyStatus
                this.details['surveyStatus'] = surveyStatus.charAt(0).toUpperCase() + surveyStatus.slice(1)
                const surveyStartDate = moment(surveyDetails.startDate).format("DD-MM-YYYY");
                this.details['startDate'] = surveyStartDate;
                const surveyEndDate = moment(surveyDetails.endDate).format("DD-MM-YYYY");
                this.details['endDate'] = surveyEndDate;
                this.details['completed'] = surveyDetails.surveyCompleteDate ? dateFormatter(surveyDetails.surveyCompleteDate) : '--'
                this.details['surveyedOn'] = surveyDetails.surveyedOn ? dateFormatter(surveyDetails.surveyedOn)  : '--'
            }).catch((error) => {
                this.$snotify.error(error.data.message, 'Error!');
            })
        },
        getAllHouses(isMounted){
            // let housesInfo = [];
            if(isMounted) {
                return surveysService.getAllHousesBySurveyId(this.$route.params._id).then((response) => {
                    response.data.response.forEach((element) => {
                        if(element.geoLoc.length > 0){
                            let house = element;
                            house['lat'] = element.geoLoc[1]
                            house['lng'] = element.geoLoc[0]
                            house['label'] = element.hnNo + "("+(element.houseStatus == "Active" ? "Completed": "Pending") + ")"
                            this.housesInfo.push(house)
                        }
                    })
                }).catch((error) => {
                this.$snotify.error(error.data.message, 'Error!');
            })
            } else {
                if(this.housesInfo.length>0){
                        this.houseLocation = true;
                } else{
                        this.houseLocation = false;
                }
            }
        },
        onLoaded() {
            this.surveyDetailsTable = this.$refs.surveyDetailsTable;
        },
        onCloseMap(){
            this.isMapActive = false
        },
        houseLocationOnMap(){
            this.getAllHouses()
            this.isMapActive = true
        }
    },
    created() {
        const promises = [];
        this.loading = true;
        if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
            promises.push(this.getSurveyInfo());
            // promises.push(this.getAllHouses());
        }
        Promise.all(promises)
            .then(() => {
                this.loading = false;
                this.ready = true;
            })
            .catch(() => {
                this.loading = false;
            });
    },
    mounted() {
        eventBus.$off("houseSurveyEvent");
        this.getAllHouses(true)
                    eventBus.$on("houseSurveyEvent", ()=> {
                        eventBus.$emit("housesLocation", this.housesInfo);
                    });
    },

};
</script>

<style>
.main {
    margin-left: 15px;
}

.shedule_date_data {
    background: #0F6940;
    padding: 10px;
    display: flex;
    margin-top: 10px;
    color: #fff;
    flex-wrap: wrap;
}

.shedule_date_inner {
    flex: 0 0 16%;
    margin-bottom: 5px;
}

.shedule_date_data_paddi {
    padding: 15px;
}

.shedule_date_inner p {
    font-size: 15px;
    font-weight: 600;
}

.shedule_date_inner h5 {
    margin-bottom: 5px;
    font-size: 14px;
    color: #0ce595;
    margin-top: 5px;
}

.collection_division_details_ssec h3 {
    font-size: 20px;
    font-weight: 700;
}

.update_trip_wrp {
    height: calc(100vh - 150px);
    overflow: auto;
    overflow-x: hidden;
}

.update_trip_wrp::-webkit-scrollbar {
    width: 5px;
}

.update_trip_wrp::-webkit-scrollbar-thumb {
    background: #888;
}

.surveyDetailsTable_paddi {
    padding-right: 15px;
}

.surveyDetailsTable_paddi .VueTables__search {
    padding-left: 15px;
}

.surveyDetailsTable_paddi .table-responsive {
    height: calc(100vh - 460px);
    overflow: auto;
    overflow-x: hidden;
}

.surveyDetailsTable_paddi .VuePagination {
    padding-left: 20px;
}

.shedule_date_inner_btm p {
    margin-bottom: 2px;
}

.view-houses{
    border-radius: 5px;
    border: 1px solid #ffffff;
    background: #0F6940;
}

.location .waste_type_pop .form-modal{
    width: 80% !important;
    height: 80% !important;
    padding: 10px 15px;
}


@media(max-width:1499px){
    .surveyDetailsTable_paddi .table-responsive {
    height: calc(100vh - 485px);
    overflow-x: auto;
}
}

@media(max-width:768px){
    .surveyDetailsTable_paddi .table-responsive {
    height: calc(100vh - 545px);
}
}
@media(max-width:767px){
    .surveyDetailsTable_paddi .table-responsive {
        overflow-x: auto;
        height: calc(100vh - 600px);
  }
  .surveyDetailsTable_paddi_res{
    padding-left: 15px;
  }
  .surveyDetailsTable_paddi_res .VueTables__search{
    padding-left: 0px;
  }
  .update_trip_wrp {
        height: calc(100vh - 220px);
    }
}

</style>



// WEBPACK FOOTER //
// surveyDetails.vue?356f2fc8